<template>
  <div>
    <b-row>
      <b-col cols="2" class="pr-0">
        <div class="nav p-2 flex-column nav-pills bg-white rounded" id="v-pills-tab" role="tablist" aria-orientation="vertical">
          <router-link 
            v-for="_town of towns" 
            :key="_town.name" 
            class="nav-link" 
            :class="{active: _town.name === town.name}"
            :to="{name: 'TownDetail', params: {townId: _town.name}}">
            {{_town.name}}
          </router-link>
        </div>
      </b-col>
      <b-col cols="10">
        <div class="hehe2 bg-white p-2 p-sm-2 p-md-3 p-lg-4 mb-3 rounded">
          <h3 class="text-primary">{{town.name}}</h3>
          <hr>
          <p>{{town.postalCode}} | 面积 {{town.area}} 平方千米</p>
          <p class="mb-0">{{town.introduction}}</p>
        </div>
        <div class="p-sm-2 p-2 p-md-3 p-lg-4 bg-white rounded">
          <h5>下辖村</h5>
          <hr>
          <ul class="list-unstyled row mb-0">
            <li v-for="village of town.villages" :key="village.id" class="col-6 col-sm-6 col-md-4 col-lg-3 mt-2">{{village.name}}</li>
          </ul>
        </div>
        <div v-for="item of town.detail" :key="item.title" class="p-sm-2 p-2 p-md-3 p-lg-4 bg-white rounded">
          <div>
            <h5>{{item.title}}</h5>
            <hr>
            <section v-html="item.content"></section>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import towns from '@/data/towns.json'
import t_371083001 from '@/data/towns/371083001.json'
import t_371083100 from '@/data/towns/371083100.json'
import t_371083101 from '@/data/towns/371083101.json'
import t_371083102 from '@/data/towns/371083102.json'
import t_371083103 from '@/data/towns/371083103.json'
import t_371083104 from '@/data/towns/371083104.json'
import t_371083105 from '@/data/towns/371083105.json'
import t_371083106 from '@/data/towns/371083106.json'
import t_371083107 from '@/data/towns/371083107.json'
import t_371083108 from '@/data/towns/371083108.json'
import t_371083109 from '@/data/towns/371083109.json'
import t_371083110 from '@/data/towns/371083110.json'
import t_371083111 from '@/data/towns/371083111.json'
import t_371083112 from '@/data/towns/371083112.json'
import t_371083114 from '@/data/towns/371083114.json'
export default {
  data() {
    return {
      towns,
      town: {},
    }
  },
  created() {
    this.mergeTownsDetail()
    let townName = this.$route.params.townId
    towns.forEach((town) => {
      if (town.name === townName) {
          this.town = town
      }
    })
  },
  beforeRouteUpdate(to, from, next) {
    let townName = to.params.townId
    towns.forEach((town) => {
      if (town.name === townName) {
          this.town = town
      }
    })
    next()
  },
  methods: {
    mergeTownsDetail() {
      let details = {}
      details['371083001'] = t_371083001.detail
      details['371083100'] = t_371083100.detail
      details['371083101'] = t_371083101.detail
      details['371083102'] = t_371083102.detail
      details['371083103'] = t_371083103.detail
      details['371083104'] = t_371083104.detail
      details['371083105'] = t_371083105.detail
      details['371083106'] = t_371083106.detail
      details['371083107'] = t_371083107.detail
      details['371083108'] = t_371083108.detail
      details['371083109'] = t_371083109.detail
      details['371083110'] = t_371083110.detail
      details['371083111'] = t_371083111.detail
      details['371083112'] = t_371083112.detail
      details['371083114'] = t_371083114.detail
      for (let town of this.towns) {
        town.detail = details[town.code]
      }
    }
  }
}
</script>
<style scoped>
.hehe {
  border: 30px solid transparent;
  border-image: url(../../assets/border.png) 300 300 round;
}
</style>